import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Router } from "@angular/router";

@Component({
    selector: 'navbar',
    templateUrl: './topnavigation.component.html',
    animations: [
        trigger('slideInOut', [
            state('in', style({
                right: '0'
            })),
            state('out', style({
                right: '-260px'
            })),
            transition('in => out', animate('400ms ease-in-out')),
            transition('out => in', animate('400ms ease-in-out'))
        ]),
    ]
})
export class TopnavigationComponent implements OnInit {

    userName: string;
    userinitial: string;
    organizationName: string;
    roleName: string;
    activeClass1: string = "";
    activeClass2: string = "";

    constructor(private router: Router) { }

    ngOnInit(): void {
        var activeUrl = this.router.url;

        if (activeUrl.indexOf("applications/application-details") > 0) {
            this.activeClass2 = "selected";
        }

        if (activeUrl.indexOf("applications/pending") > 0) {
            this.activeClass2 = "selected";
        }

        if (activeUrl.indexOf("applications/call-back") > 0) {
            this.activeClass2 = "selected";
        }

        if (activeUrl.indexOf("applications/resolved") > 0) {
            this.activeClass2 = "selected";
        }

        if (activeUrl.indexOf("reporting/site-traffic") > 0) {
            this.activeClass1 = "selected";
        }

        this.userName = "Jenny Hogarth";
        this.userinitial = "JH";
        this.organizationName = "ABC";
        this.roleName = "Role";
    }

    isBtnActive: boolean = false;

    menuState: string = 'out';

    toggleMenu() {
        // 1-line if statement that toggles the value:
        this.menuState = this.menuState === 'out' ? 'in' : 'out';
        this.isBtnActive = !this.isBtnActive;
    }

    onLogOff() {
        this.router.navigate(['/']);
    }

}
